import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './TeamDetails.m.sass';
import Icon from '../../../components/Icon';
import { match } from '../../../utils/patternMatchUtil';
import MembersView from './MembersView';
import ContentLoading from '../../../components/ContentLoading';
import ContentError from '../../../components/ContentError';
import InviteToTeamModal from '../InviteToTeamModal';
import BillingView from './BillingView';
import InfoView from './InfoView';
import AddToTeamModal from '../AddToTeamModal';
var TeamDetails = function TeamDetails(_ref) {
  var state = _ref.state,
    onBackClick = _ref.onBackClick,
    _ref$billingViews = _ref.billingViews,
    billingViews = _ref$billingViews === void 0 ? ['BILLING', 'PAYOUT'] : _ref$billingViews;
  var showBillingMethods = billingViews.includes('BILLING') && state.sessionStore.workspace.features.billing.enabled;
  var showPayoutMethods = billingViews.includes('PAYOUT') && state.sessionStore.workspace.features.billing.enabled;
  return state.activate.match({
    pending: function pending() {
      return /*#__PURE__*/React.createElement(ContentLoading, null);
    },
    rejected: function rejected(err) {
      return /*#__PURE__*/React.createElement(ContentError, {
        error: err
      });
    },
    resolved: function resolved() {
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.root)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.box
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.title
      }, /*#__PURE__*/React.createElement("a", {
        onClick: onBackClick,
        className: styles.backBtn
      }, "Teams"), ' / ', /*#__PURE__*/React.createElement("span", {
        className: styles.teamName
      }, state.team.name))), /*#__PURE__*/React.createElement("div", {
        className: styles.split
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.sidebar
      }, /*#__PURE__*/React.createElement(SidebarItem, {
        state: state,
        id: "MEMBERS",
        icon: /*#__PURE__*/React.createElement(Icon, {
          material: true,
          name: "group"
        })
      }, "Members"), showBillingMethods && /*#__PURE__*/React.createElement(SidebarItem, {
        state: state,
        id: "BILLING",
        icon: /*#__PURE__*/React.createElement(Icon, {
          material: true,
          name: "credit card"
        })
      }, "Billing"), showPayoutMethods && /*#__PURE__*/React.createElement(SidebarItem, {
        state: state,
        id: "PAYOUT",
        icon: /*#__PURE__*/React.createElement(Icon, {
          material: true,
          name: "money"
        })
      }, "Payout"), /*#__PURE__*/React.createElement(SidebarItem, {
        state: state,
        id: "INFO",
        icon: /*#__PURE__*/React.createElement(Icon, {
          material: true,
          name: "info outline"
        })
      }, "Info")), /*#__PURE__*/React.createElement("div", {
        className: styles.content
      }, match(state.currentTab, _defineProperty({
        MEMBERS: function MEMBERS() {
          return /*#__PURE__*/React.createElement(MembersView, {
            state: state
          });
        },
        BILLING: function BILLING() {
          return /*#__PURE__*/React.createElement(BillingView, {
            view: "BILLING",
            state: state
          });
        },
        PAYOUT: function PAYOUT() {
          return /*#__PURE__*/React.createElement(BillingView, {
            view: "PAYOUT",
            state: state
          });
        },
        INFO: function INFO() {
          return /*#__PURE__*/React.createElement(InfoView, {
            state: state
          });
        }
      }, match.DEFAULT, function () {
        return 'Unknown view ' + state.currentTab;
      }))))), /*#__PURE__*/React.createElement(InviteToTeamModal, {
        state: state.inviteTeamMemberState
      }), /*#__PURE__*/React.createElement(AddToTeamModal, {
        state: state.addTeamMemberState
      }));
    }
  });
};
export default observer(TeamDetails);
var SidebarItem = observer(function SidebarItem(_ref2) {
  var state = _ref2.state,
    id = _ref2.id,
    icon = _ref2.icon,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement("a", {
    className: cx(styles.sidebarItem, state.currentTab === id && styles.active),
    onClick: state.setTab.bind(state, id)
  }, icon, /*#__PURE__*/React.createElement("span", {
    className: styles.sidebarItemTitle
  }, children));
});
//# sourceMappingURL=index.js.map
